// extracted by mini-css-extract-plugin
export default {"dialogContainer":"ConfirmDialog_dialogContainer__XWSo-","actionButtons":"ConfirmDialog_actionButtons__eugET","confirm":"ConfirmDialog_confirm__2duH3"};